import { createSelector } from 'reselect';
import { compose, get, compact, getOr, eq, sum, over, negate } from 'lodash/fp';
import { TextKey } from '@mews-commander/enums';
import { DENSE_B2B_LIGHT_THEME } from '@optimus-web/theme';
import { getToken } from '@optimus-web/core';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { moduleSelector } from '../module';

export const getOrderStatistics = compose(get('orderStatistics'), moduleSelector);
export const isLoaded = compose(get('isLoaded'), getOrderStatistics);
export const getLastModified = compose(getOr(0, 'lastModified'), getOrderStatistics);

export const hasOrders = compose(
    negate(eq(0)),
    sum,
    over([get('processableOrderCount'), get('confirmableOrderCount'), get('missedOrderCount')]),
    getOrderStatistics
);

export const getOrderStatisticsChartData = createSelector(getOrderStatistics, getContainer, (stats, container) => {
    const { processableOrderCount, confirmableOrderCount, missedOrderCount } = stats;
    const { appLocalizationComponent } = container();
    return compact([
        processableOrderCount > 0 && {
            value: processableOrderCount,
            color: getToken('legacyTagBorderDenim')({ theme: DENSE_B2B_LIGHT_THEME }),
            label: appLocalizationComponent.localizeText(TextKey.OrdersToProcess),
        },
        confirmableOrderCount > 0 && {
            value: confirmableOrderCount,
            color: getToken('legacyTagBorderTangerine')({ theme: DENSE_B2B_LIGHT_THEME }),
            label: appLocalizationComponent.localizeText(TextKey.OrdersToConfirm),
        },
        missedOrderCount > 0 && {
            value: missedOrderCount,
            color: getToken('legacyTagBorderTangerine')({ theme: DENSE_B2B_LIGHT_THEME }),
            label: appLocalizationComponent.localizeText(TextKey.OptionalReservationsPastDeadLine),
        },
    ]);
});
